import type { CanonicalSchema } from './canonical-schema.js'
import { CLIENT_V1 } from './client.v1.js'
import { CONVERSION_V1 } from './conversion.v1.js'
import { ORGANIZATION_UNIT_V1 } from './organization-unit.v1.js'
import { PRODUCT_V1 } from './product.v1.js'
import { USER_V1 } from './user.v1.js'

export * from './canonical-schema.js'
export { CLIENT_V1 } from './client.v1.js'
export { CONVERSION_V1 } from './conversion.v1.js'
export { ORGANIZATION_UNIT_V1 } from './organization-unit.v1.js'
export { PRODUCT_V1 } from './product.v1.js'
export { USER_V1 } from './user.v1.js'

/**
 * The canonical schema registry (TO-414 REQ-003), a published-language
 * contract (ADR-0030): file-exchange reads it from here, never from a domain
 * service. Append-only — add a new `name@version` file and entry; never change
 * or remove a published one (a fingerprint test enforces this).
 */
export const CANONICAL_SCHEMAS: readonly CanonicalSchema[] = Object.freeze([
	ORGANIZATION_UNIT_V1,
	PRODUCT_V1,
	CONVERSION_V1,
	CLIENT_V1,
	USER_V1,
])

/** The registry entry for `name@version`, or `undefined`. */
export const getCanonicalSchema = (name: string, version: number): CanonicalSchema | undefined =>
	CANONICAL_SCHEMAS.find((schema) => schema.name === name && schema.version === version)
